export const environment = {
  apiUrl: 'https://api.licensecomply.com',
  production: true,
};
